import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client/api-client";
import { API_ANNOUCEMENT_UPLOAD_CSV_PATH, API_ANNOUCEMENT_UPLOAD_PATH, API_ANNOUNCEMENT_ACTION, API_GET_ANNOUNCEMENT_CATEGORIES, API_GET_ANNOUNCEMENT_LIST, API_GET_AUDIENCE_KEYS, API_GET_AUDIENCE_KEYS_VALUES, API_GET_AUDIENCE_LIST, API_GET_AUDIENCE_LIST_MINIMAL, API_GET_USER_ANNOUNCEMENTS, API_PREVIEW_AUDIENCE_QUERY, API_PUT_ANNOUNCEMENT, API_PUT_AUDIENCE_CSV, API_PUT_AUDIENCE_QUERY_BUILDER } from "../../route/api.routes";

const config = {
  name: "annoucements",
};

export const getKeysAudience: any = createAsyncThunk(
  `${config.name}/getKeysAudience`,
  async () => {
    return await Client.get(API_GET_AUDIENCE_KEYS);
  }
);
export const getKeysAudienceValues: any = createAsyncThunk(
  `${config.name}/getKeysAudienceValues`,
  async (key:string) => {
    return await Client.get(API_GET_AUDIENCE_KEYS_VALUES, {params: {key}});
  }
);
export const putAudienceQueryBuilder: any = createAsyncThunk(
  `${config.name}/putAudienceQueryBuilder`,
  async (payload:any) => {
    return await Client.put(API_PUT_AUDIENCE_QUERY_BUILDER, payload);
  }
);
export const previewAudienceQuery: any = createAsyncThunk(
  `${config.name}/previewAudienceQuery`,
  async ({payload, params}:any) => {
    return await Client.post(API_PREVIEW_AUDIENCE_QUERY, payload, {params});
  }
);
export const announcementUploadCsv: any = createAsyncThunk(
  `${config.name}/announcementUploadCsv`,
  async (params:any) => {
    return await Client.get(API_ANNOUCEMENT_UPLOAD_CSV_PATH, {params});
  }
);
export const putAudienceCreateCsv: any = createAsyncThunk(
  `${config.name}/putAudienceCreateCsv`,
  async (payload:any) => {
    return await Client.put(API_PUT_AUDIENCE_CSV, payload);
  }
);
export const putAnnouncementCreateEdit: any = createAsyncThunk(
  `${config.name}/putAnnouncementCreateEdit`,
  async (payload:any) => {
    return await Client.put(API_PUT_ANNOUNCEMENT, payload);
  }
);
export const uploadFilePathAudience: any = createAsyncThunk(
  `${config.name}/uploadFilePathAudience`,
  async (data: any) => {
    return await Client.get(API_ANNOUCEMENT_UPLOAD_CSV_PATH, {params: data});
  }
);
export const uploadFilePathAnnouncement: any = createAsyncThunk(
  `${config.name}/uploadFilePathAnnouncement`,
  async (body: any) => {
    return await Client.post(API_ANNOUCEMENT_UPLOAD_PATH, body);
  }
);
export const getAudienceList: any = createAsyncThunk(
  `${config.name}/getAudienceList`,
  async (data: any) => {
    return await Client.get(API_GET_AUDIENCE_LIST, {params: data});
  }
);
export const getAnnouncementList: any = createAsyncThunk(
  `${config.name}/getAnnouncementList`,
  async (data: any) => {
    return await Client.get(API_GET_ANNOUNCEMENT_LIST, {params: data});
  }
);
export const getAnnouncementCategories: any = createAsyncThunk(
  `${config.name}/getAnnouncementCategories`,
  async () => {
    return await Client.get(API_GET_ANNOUNCEMENT_CATEGORIES);
  }
);
export const getAudienceListMinimal: any = createAsyncThunk(
  `${config.name}/getAudienceListMinimal`,
  async () => {
    return await Client.get(API_GET_AUDIENCE_LIST_MINIMAL);
  }
);
export const announcementAction: any = createAsyncThunk(
  `${config.name}/announcementAction`,
  async (params:any) => {
    return await Client.get(API_ANNOUNCEMENT_ACTION, {params});
  }
);
export const getUserAnnouncementList: any = createAsyncThunk(
  `${config.name}/getUserAnnouncementList`,
  async (params:any) => {
    return await Client.get(API_GET_USER_ANNOUNCEMENTS, {params});
  }
);

export const annoucementsSlice = createSlice({
  name: config.name,
  initialState: {
    loading: false,
    annoucements: [] as any,
    audiences: [] as any,
    pagination: { offset: 0, limit: 10, total: 0 },
    audiencePreview: [] as any,
    paginationPreview : { offset: 0, limit: 10, total: 0 },
    error: "" as string,
    filters: null as any,
    sorters: {
      sort_column: "due_date",
      sort_val: null,
    } as any
  },
  reducers: {
    reset: (state) => {
      state.annoucements = [];
      state.audiences = [];
      state.loading = false;
      state.pagination = { offset: 0, limit: 10, total: 0 };
      state.paginationPreview = { offset: 0, limit: 10, total: 0 };
      state.audiencePreview = [] as any;
      state.error = "";
    },
    resetPagination: (state) => {
      state.pagination = { offset: 0, limit: 10, total: 0 };
      state.paginationPreview = { offset: 0, limit: 10, total: 0 };
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSorters: (state, action) => {
      state.sorters = action.payload;
    },
  },
  extraReducers(builder) {
    builder
    .addCase(previewAudienceQuery.pending, (state) => {
      state.loading = true;
      state.error = "";
    })
    .addCase(previewAudienceQuery.fulfilled, (state, action) => {
      state.loading = false;
      const offset = parseInt(action?.payload?.data?.data?.offset || '0');

      state.audiencePreview = action?.payload?.data?.data?.items?.map((val:any, index: number)=>{
        return {
          ...val, sno: index + offset + 1
        }
      });
      state.paginationPreview = {
        offset: action?.payload?.data?.data?.offset,
        limit: action?.payload?.data?.data?.limit,
        total: action?.payload?.data?.data?.total,
      };
    })
    .addCase(previewAudienceQuery.rejected, (state) => {
      state.loading = false;
      state.error = "";
    })
    .addCase(getAudienceList.pending, (state) => {
      state.loading = true;
      state.error = "";
    })
    .addCase(getAudienceList.fulfilled, (state, action) => {
      state.loading = false;
      const offset = parseInt(action?.payload?.data?.data?.offset || '0');

      state.audiences = action?.payload?.data?.data?.items?.map((val:any, index: number)=>{
        return {
          ...val, sno: index + offset + 1
        }
      });
      state.pagination = {
        offset: action?.payload?.data?.data?.offset,
        limit: action?.payload?.data?.data?.limit,
        total: action?.payload?.data?.data?.total,
      };
    })
    .addCase(getAudienceList.rejected, (state) => {
      state.loading = false;
      state.error = "";
    })
    .addCase(getAnnouncementList.pending, (state) => {
      state.loading = true;
      state.error = "";
    })
    .addCase(getAnnouncementList.fulfilled, (state, action) => {
      state.loading = false;
      const offset = parseInt(action?.payload?.data?.data?.offset || '0');

      state.annoucements = action?.payload?.data?.data?.items?.map((val:any, index: number)=>{
        return {
          ...val, sno: index + offset + 1
        }
      });
      state.pagination = {
        offset: action?.payload?.data?.data?.offset,
        limit: action?.payload?.data?.data?.limit,
        total: action?.payload?.data?.data?.total,
      };
    })
    .addCase(getAnnouncementList.rejected, (state) => {
      state.loading = false;
      state.error = "";
    })
    
  },
});

export const { setFilters, resetPagination, setSorters, reset } = annoucementsSlice.actions;

export default annoucementsSlice.reducer;
